import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js';

export default class FiltersProducts {
    constructor() {
        this.setFilters();
        this.setValues();

        this.triggeredBy = arguments.length ? arguments[0] : null;
    }

    /**
     * Recense les filtres de type SingleFilter qui seront pris en compte dans la requête.
     */
    setFilters() {
        this.filters = document.querySelectorAll(['[is="single-filter"]', 'single-filter']);
    }

    /**
     * Recense les valeurs définies dans les différents filtres de type SingleFilter.
     */
    setValues() {
        this.values = {};

        const search = this.getSearchValueFromUrl();
        if (search) {
            this.values.s = search;
        }

        this.filters.forEach((filter) => {
            let value = filter.getFilterValue();

            // Ne tient pas compte de la valeur si elle est nulle ou vide
            if ( ! value || value.length === 0) {
                return;
            }

            this.values[filter.filterName] = value;
        });
    }

    /**
     * Retourne la valeur du champ recherche, identifiable dans l'URL via le paramètre 's'.
     */
    getSearchValueFromUrl() {
        const queryString = window.location.href.split('?')[1] ?? null;

        if ( ! queryString) {
            return null;
        }

        let returnValue = null;

        queryString.split('&').forEach((pair) => {
            const [key, value] = pair.split('=');
            if (key === 's') {
                returnValue = value;
            }
        });

        return returnValue;
    }

    /**
     * Lance la requête ajax correspondant aux paramètres des filtres
     * et affiche le résultat dans le DOM.
     */
    query() {
        const requestor = new Requestor();
        requestor.sendRequest(
            this.getQueryUrl(),
            'GET',
            this.values,
            // Success callback
            (data) => {
                // Affiche les templates dans le DOM
                if (data.templates) {
                    for (const [id, content] of Object.entries(data.templates)) {
                        const target = document.getElementById(id);
                        if (target) {
                            target.innerHTML = content;
                        }
                    }
                }
                // Modifie l'URL pour qu'elle corresponde aux nouveaux paramètres
                if (data.history && data.history.fullUrl) {
                    window.history.pushState({}, window.title, data.history.fullUrl);
                }
                // TODO: rouvre le filtre actif
                if (this.triggeredBy) {
                    this.setFilters();
                    this.filters.forEach((filter) => {
                        if (filter.filterName === this.triggeredBy.name) {
                            // TODO: rouvrir le filtre utilisé en dernier
                            filter.click();
                        }
                    });
                }
            },
            // Error callback
            (data) => {
                console.error(data);
            }
        );
    }

    /**
     * Désactive la valeur "value" du filtre "name" dans les valeurs recensées
     * et relance la requête.
     *
     * @param name
     * @param value
     */
    removeFilter(name, value) {

        for (const [key, val] of Object.entries(this.values)) {
            if (name === key) {
                if (Array.isArray(val)) {
                    this.values[name] = val.filter((item) => value != item);
                } else {
                    delete this.values[name];
                }
            }
        }

        this.query();
    }

    /**
     * Supprime tous les paramètres de l'URL en cours pour envoyer la requête sur une base vierge.
     *
     * @returns {string}
     */
    getQueryUrl() {
        return window.location.protocol + '//' + window.location.host + window.location.pathname;
    }
}
